import { GeocodeErrorCode } from "@/domain/participant.interface";

export type GeocodeAlertKey =
  | "geocode.alert.primary-not-found"
  | "geocode.alert.secondary-not-found"
  | "geocode.alert.both-not-found"
  | "geocode.alert.lookup-unavailable";

export type GeocodeSaveSignals = {
  geocodedPrimary?: boolean;
  geocodedSecondary?: boolean;
  geocodePrimaryError?: GeocodeErrorCode;
  geocodeSecondaryError?: GeocodeErrorCode;
};

export const getGeocodeAlertKey = (
  result: GeocodeSaveSignals,
): GeocodeAlertKey | null => {
  const primaryError = result.geocodePrimaryError;
  const secondaryError = result.geocodeSecondaryError;

  if (!primaryError && !secondaryError) {
    return null;
  }

  if (
    primaryError === "LOOKUP_UNAVAILABLE" ||
    secondaryError === "LOOKUP_UNAVAILABLE"
  ) {
    return "geocode.alert.lookup-unavailable";
  }

  if (primaryError === "NOT_FOUND" && secondaryError === "NOT_FOUND") {
    return "geocode.alert.both-not-found";
  }

  if (primaryError === "NOT_FOUND") {
    return "geocode.alert.primary-not-found";
  }

  if (secondaryError === "NOT_FOUND") {
    return "geocode.alert.secondary-not-found";
  }

  return null;
};
